const ROWS = [
  {
    title: "State rules",
    body: "Oregon: testing in grades 3, 5, 8 and 10, by August 15. Washington: an annual assessment for ages 8–18.",
  },
  {
    title: "The test",
    body: "TerraNova Third Edition Survey, grades 1–12 — nationally normed, approved in Oregon and accepted in Washington.",
  },
  {
    title: "Test day",
    body: "In person at your home or co-op. Plan 2 hours for grades 1–3, 2½ hours for grades 4–12, with a break in the middle.",
  },
  {
    title: "Pricing",
    body: "$70 per student at your home; $50 each for groups of 4 or more. You pay when you book, and that holds your slot.",
  },
];

export default function QuickReference() {
  return (
    <section data-testid="quick-reference-section" className="bg-[#EBEBFA] border-t border-[#1A243B]/10">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <h2 className="text-3xl md:text-4xl text-[#1A243B] mb-10">Quick reference</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {ROWS.map((r, i) => (
            <div key={r.title} data-testid={`quick-ref-${i}`} className="bg-white rounded-3xl p-7 shadow-sm">
              <h3 className="text-sm font-bold tracking-widest uppercase text-[#2D3748]/70 mb-3">{r.title}</h3>
              <p className="text-[#2D3748] text-base leading-relaxed">{r.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
